module.exports = __webpack_public_path__ + "static/media/prabhupada.a6b54c1a.webp";